import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const siteSliders= () => {
    // Re-entrant: the block editor calls this again after every block render,
    // and a second Swiper on the same element stacks instances. On the front
    // end this loop is a no-op — nothing is initialised at DOMContentLoaded.
    document.querySelectorAll('.swiper').forEach((el) => {
        if (el.swiper) {
            el.swiper.destroy(true, true);
        }
    });

    const companyLogoSliders = () => {
        // Variables
        let companyLogoSliders = document.querySelectorAll('.company-logo-slider');
        // Check if company logo sliders exist
        if (companyLogoSliders.length === 0) {
            return;
        }
        // Loop through each company logo slider
        companyLogoSliders.forEach((slider) => {
            let slides = slider.querySelectorAll('.swiper-slide');
            // Add class to the slider if it has less than 4 slides
            if (slides.length <= 4) {
                slider.classList.add('less-than');
            }
            // Initialize Swiper
            let swiperSlide = new Swiper(slider, {
                spaceBetween:  36,
                slidesPerView: 2,
                loop: true,
                autoplay: {
                    delay: 0,
                    disableOnInteraction: false,
                },
                speed:2000,
                allowTouchMove: false, // Disable touch/drag functionality for a continuous scroll
                breakpoints: {
                    576: {
                        slidesPerView: 3,
                        loop: true,
                    },
                    768: {
                        slidesPerView: 5,
                        loop: true,
                    },
                    992: {
                        slidesPerView: 6,
                        spaceBetween: 36,
                        loop: true,
                    },
                    1400: {
                        slidesPerView: 7,
                        spaceBetween: 62,
                        loop: false,
                    },
                },
            });

            window.addEventListener('load', () => {
                swiperSlide.updateSize();
                swiperSlide.updateSlides();
            });
        });
    };

    const ourPartnersSlider = () => {
        // Variables
        let ourPartnersSlider = document.querySelectorAll('.our-partners-logo-slider');
        // Check if our partners logo sliders exist
        if (ourPartnersSlider.length === 0) {
            return;
        }
        // Loop through each our partners logo slider
        ourPartnersSlider.forEach((slider) => {
            let slides = slider.querySelectorAll('.swiper-slide');
            // Add class to the slider if it has less than 4 slides
            if (slides.length <= 4) {
                slider.classList.add('less-than');
            }
            // Initialize Swiper
            let swiperSlide = new Swiper(slider, {
                spaceBetween:  36,
                slidesPerView: 2,
                loop: true,
                autoplay: {
                    delay: 0,
                    disableOnInteraction: false,
                },
                speed:2000,
                allowTouchMove: false, // Disable touch/drag functionality for a continuous scroll
                breakpoints: {
                    576: {
                        slidesPerView: 3,
                        loop: true,
                    },
                    768: {
                        slidesPerView: 5,
                        loop: true,
                    },
                    992: {
                        slidesPerView: 6,
                        spaceBetween: 36,
                        loop: true,
                    },
                    1400: {
                        slidesPerView: 7,
                        loop: true,
                    },
                },
            });
        });
    };

    const testimonialSlider = () => {
        // Variables
        let testimonialSliders = document.querySelectorAll('.testimonial-slider');
        // Check if USP sliders exist
        if (testimonialSliders.length === 0) {
            return;
        }
        // Loop through each USP slider
        testimonialSliders.forEach((slider) => {
            // Initialize Swiper
            let swiperSlide = new Swiper(slider, {
                spaceBetween: 24,
                slidesPerView: 1,
                loop: true,
                speed: 700,
                autoplay: {
                    delay: 1200,
                    disableOnInteraction: true,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        loop: true,
                    },
                    1200: {
                        slidesPerView: 3,
                        loop: true,
                    },
                },
                navigation: {
                    nextEl: '.swiper-testimonial-button-next',
                    prevEl: '.swiper-testimonial-button-prev',
                },
            });
        });
    };

    const ourTrainingSlider = () => {
        // Variables
        let ourTrainingSliders = document.querySelectorAll('.our-training-slider');
        // Check if our training sliders exist
        if (ourTrainingSliders.length === 0) {
            return;
        }
        // Loop through each our training slider
        ourTrainingSliders.forEach((slider) => {
            // Initialize Swiper
            let swiperSlide = new Swiper(slider, {
                spaceBetween: 27,
                slidesPerView: 1.2,
                loop: true,
                speed: 700,
                autoplay: {
                    delay: 1200,
                    disableOnInteraction: true,
                },
                breakpoints: {
                    576: {
                        slidesPerView: 1,
                        loop: true,
                    },
                    768: {
                        slidesPerView: 2,
                        loop: true,
                    },
                    1200: {
                        slidesPerView: 3,
                        loop: true,
                    },
                    1400: {
                        slidesPerView: 4,
                        loop: false,
                    },
                },
                // navigation: {
                //     nextEl: '.swiper-testimonial-button-next',
                //     prevEl: '.swiper-testimonial-button-prev',
                // },
            });
        });
    };

    const trainingSlider = () => {
        // Variables
        let trainingSliders = document.querySelectorAll('.training-slider');
        // Check if USP sliders exist
        if (trainingSliders.length === 0) {
            return;
        }
        // Loop through each USP slider
        trainingSliders.forEach((slider) => {
            // Initialize Swiper
            let swiperSlide = new Swiper(slider, {
                spaceBetween: 24,
                slidesPerView: 1.15,
                loop: true,
                speed: 700,
                breakpoints: {
                    768: {
                        slidesPerView: 2.2,
                        loop: true,
                    },
                    1200: {
                        slidesPerView: 3.2,
                        loop: true,
                    },
                    1400: {
                        slidesPerView: 3.5,
                        loop: true,
                    },
                },
                navigation: {
                    nextEl: '.swiper-training-button-next',
                    prevEl: '.swiper-training-button-prev',
                },
            });
        });
    };

    const phishingSubsSlider = () => {
        // Variables
        let phishingSubsSliders = document.querySelectorAll('.phishing-subs-slider');
        // Check if USP sliders exist
        if (phishingSubsSliders.length === 0) {
            return;
        }
        // Loop through each USP slider
        phishingSubsSliders.forEach((slider) => {
            // Initialize Swiper
            let swiperSlide = new Swiper(slider, {
                spaceBetween: 24,
                slidesPerView: 1,
                loop: true,
                speed: 700,
                // autoplay: {
                //     delay: 1200,
                //     disableOnInteraction: true,
                // },
                breakpoints: {
                    576: {
                        slidesPerView: 1.4,
                        loop: true,
                    },
                    992: {
                        slidesPerView: 1.8,
                        loop: true,
                    },
                },
                navigation: {
                    nextEl: '.swiper-training-button-next',
                    prevEl: '.swiper-training-button-prev',
                },
            });
        });
    };

    const featuredPostSlider = () => {
        // Variables
        let featuredPostSliders = document.querySelectorAll('.featured-post-slider');
        // Check if USP sliders exist
        if (featuredPostSliders.length === 0) {
            return;
        }
        // Loop through each USP slider
        featuredPostSliders.forEach((slider) => {
            // Initialize Swiper
            let swiperSlide = new Swiper(slider, {
                spaceBetween: 24,
                slidesPerView: 1,
                loop: true,
                speed: 500,
                // autoplay: {
                //     delay: 1200,
                //     disableOnInteraction: true,
                // },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        loop: true,
                    },
                    1200: {
                        slidesPerView: 3,
                        loop: true,
                    },
                },
                navigation: {
                    nextEl: '.featured-btn-next',
                    prevEl: '.featured-btn-prev',
                },
            });
        });
    };

    const latestPostSlider = () => {
        // Variables
        let latestPostSliders = document.querySelectorAll('.latest-post-slider');
        // Check if USP sliders exist
        if (latestPostSliders.length === 0) {
            return;
        }
        // Loop through each USP slider
        latestPostSliders.forEach((slider) => {
            // Initialize Swiper
            let swiperSlide = new Swiper(slider, {
                spaceBetween: 24,
                slidesPerView: 1,
                loop: true,
                speed: 500,
                // autoplay: {
                //     delay: 1200,
                //     disableOnInteraction: true,
                // },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        loop: true,
                    },
                    1200: {
                        slidesPerView: 3,
                        loop: true,
                    },
                },
                navigation: {
                    nextEl: '.latest-btn-next',
                    prevEl: '.latest-btn-prev',
                },
            });
        });
    };

    // Init Functions
    companyLogoSliders();
    ourTrainingSlider();
    ourPartnersSlider();
    testimonialSlider();
    trainingSlider();
    phishingSubsSlider();
    featuredPostSlider();
    latestPostSlider();
};

// content loaded
document.addEventListener('DOMContentLoaded', () => {
    siteSliders();
});

// Reachable entry point for the block editor driver (inc/acf-blocks-editor.js),
// which cannot import. The name must match CONFIG.initAll in that file.
if (typeof window !== 'undefined') {
    window.ccmSiteSliders = siteSliders;
}
